export const transformResponseReturnProtectionProduct = product => {
  return {
    product_title: product.product_title,
    product_image_url: product.product_image_url,
    default_product_title: product.default_product_title,
    default_product_image_url: product.default_product_image_url,
  }
}

export const transformRequestEditReturnProtectionProduct = ({ storeId, title, image }) => {
  const product = new FormData()
  product.append('product_title', title)

  if (image) product.append('product_image', image)

  return { storeId, product }
}

export const transformRequestResetReturnProtectionProduct = ({ storeId }) => {
  return {
    storeId,
    product: {
      product_title: null,
      product_image: null,
    },
  }
}
